import React, { createContext } from "react";
import PropTypes from "prop-types";

// Status context shell. The per-user alerts (certificate / membership /
// subscription expiry, unpaid packages) used to be shown here as ephemeral
// toasts; they are now consolidated into a single persistent surface
// (<AlertsList/> fed by the `/user-alerts` endpoint).
export const StatusContext = createContext({});

const StatusProvider = ({ children }) => {
  return <StatusContext.Provider value={{}}>{children}</StatusContext.Provider>;
};

StatusProvider.displayName = "StatusProvider";

StatusProvider.propTypes = {
  children: PropTypes.node,
};

export default StatusProvider;
